import withFraction from "./withFraction"; 

export default function parseInstructions(instructions, ingredients, units) {
  // entire instructions array
  const parsedInstructions = instructions.map(section => {
    // by section
    const steps = section.steps.map(steps => {
      // variable for new text string
      let newText = steps.text
      
      // handle strings surrounded by "#" (ingredient names w/ matching amounts)
      // match = original string, group = matched string w/o "#"
      newText = newText.replace(/#([^#]+)#/g, (match, group) => {
        // search for the matching ingredient in the ingredients array
        const matchingIngredient = ingredients.flatMap(
          (ingredientsList) => ingredientsList.items
        ).find(
          (item) => 
            // if an ingreient name includes the "group" (or vice versa)
            item.name.toLowerCase().includes(group) || 
            group.includes(item.name.toLowerCase()) ||
            // if part of the ingredient name includs part of the "group" (or vice versa)
            item.name.toLowerCase().split(" ").some((word) => group.includes(word)) ||
            group.split(" ").some((word) => item.name.toLowerCase().includes(word))
        );
        // if there is a matching ingredient, replace string
        if (matchingIngredient) {
          return `<ingredient-name>${group}</ingredient-name> (<ingredient-amount><ingredient-number>${withFraction(matchingIngredient.number)}</ingredient-number>${matchingIngredient.unit ? ` <ingredient-unit>${matchingIngredient.unit}</ingredient-unit>` : ''}</ingredient-amount>)`;
        }
        // if not, keep the "match"
        return match
      });

      // bold strings surrounded by "*" (ingredient names w/o matching amounts)
      newText = newText.replace(/\*(.*?)\*/g, (match, group) => `<ingredient-name>${group}</ingredient-name>`);

      // handle strings surrounded by "_" (degrees)
      newText = newText.replace(/_(.+?)_/g, (match, group) => {
        // if 'metric' convert from F to C
        if (units === 'metric') {
          const fahrenheit = parseInt(group, 10);
          const celsius = Math.round((fahrenheit - 32) * (5 / 9));
          return `${celsius}°C`;
        }
        return group; // If not 'metric', just remove underscores
      });
      
      return { ...steps, text: newText }
    })
    
    return {...section, steps}
  })

  return parsedInstructions;
}
